import { APPSERVER_API_PREFIX } from '../axios/axios.constants';
import { getAxiosInstance } from '../axios/axios.utilities';
import type { AxiosInstance } from 'axios';

export type GraphQLRequestOverrides = {
  /** Override the axios instance for this request (e.g. the instance provided by <ApiProvider>). */
  axiosInstance?: AxiosInstance;
};

/**
 * Sends a GraphQL document to the appserver and unwraps the response payload, throwing when the response carries
 * GraphQL errors.
 */
export async function executeGraphQL<TData, TVariables>(
  document: string,
  variables?: TVariables,
  overrides?: GraphQLRequestOverrides,
): Promise<TData> {
  const axiosInstance = overrides?.axiosInstance ?? getAxiosInstance();
  const response = await axiosInstance.request<{ data: TData; errors?: { message: string }[] }>({
    method: 'post',
    url: `${APPSERVER_API_PREFIX}/graphql`,
    data: { query: document, variables },
  });

  if (response.data.errors?.length) {
    throw new Error(response.data.errors.map((e) => e.message).join('\n'));
  }

  return response.data.data;
}
